import ToggleSwitch from "./ToggleSwitch";

/**
 * Uniform settings toggle row: label (+ optional description) on the left, a
 * `ToggleSwitch` aligned to the right. The single row pattern for every toggle
 * on the settings screens.
 */
export default function SettingToggleRow({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  srLabel,
}: {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  srLabel?: string;
}) {
  return (
    <div
      className={`flex justify-between gap-4 ${
        description ? "items-start" : "items-center"
      }`}
    >
      <div className="min-w-0">
        <p className="text-sm font-medium text-white">{label}</p>
        {description && (
          <p className="mt-0.5 text-sm/6 text-gray-400">{description}</p>
        )}
      </div>
      <ToggleSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        srLabel={srLabel ?? label}
      />
    </div>
  );
}
